import React from 'react';
import { t } from 'Src/i18n';
import { ADULTS_NUMBER_MIN } from 'Utils/faceting/constants';
import { FilterWho } from 'Components/widgets/criteria/criteria-who/filter-who/FilterWho';
import { IS_INVALID, IS_VALID } from 'Components/frameworks/form-validator-hoc/validationStates';
import { timestampToApiDate } from 'Utils/date/apiDate';
import { isAdult } from 'Utils/date/dateUtils';
import type { CriteriaForSearch } from 'Components/widgets/booking-breadcrumb/EditCriteria.utils';
import 'Components/widgets/booking-breadcrumb/EditCriteria.utils';
import { makeWidgetProps } from 'Src/types/widget-helpers';
export const CriteriaAttendeesSelectorContent = ({
  newCriteria,
  setNewCriteria,
}: {
  newCriteria: CriteriaForSearch;
  setNewCriteria: (arg0: CriteriaForSearch) => void;
}) => {
  const dateFormat = t('booking.form.dateFormat');
  const dayPlaceholder = t('booking.form.dayPlaceholder');
  const monthPlaceholder = t('booking.form.monthPlaceholder');
  const yearPlaceholder = t('booking.form.yearPlaceholder');
  return (
    <div className="text-black">
      <FilterWho
        {...makeWidgetProps<React.ComponentProps<typeof FilterWho>>({
          addChildcareLabel: t('faceting.who.addChildcare'),
          adultsLabel: t('faceting.who.adults'),
          adultsNumber: newCriteria?.attendees?.adults,
          changeKid: (kidNumber, newKid) => {
            const newCriteriakidsWithUpdatedKid = newCriteria?.attendees?.kids.map((kid, idx) => {
              return kidNumber === idx
                ? {
                    ...newKid,
                    ...(newKid.birthdate && !isAdult(newKid.birthdate as number)
                      ? {
                          status: IS_VALID,
                        }
                      : {}),
                    ...(newKid.birthdate
                      ? {
                          birthdate: timestampToApiDate(newKid.birthdate as number),
                        }
                      : {}),
                  }
                : kid;
            });
            setNewCriteria(
              makeWidgetProps<CriteriaForSearch>({
                ...newCriteria,
                attendees: { ...newCriteria?.attendees, kids: newCriteriakidsWithUpdatedKid },
              }),
            );
          },
          changeKidsNumber: (newKidNumber) => {
            const criteriaKids = newCriteria?.attendees?.kids;
            const newKids = new Array(newKidNumber)
              .fill({
                status: IS_INVALID,
                childcareIncluded: false,
              })
              ?.map((kid, index) => ({ ...kid, ...criteriaKids[index] }));
            setNewCriteria(
              makeWidgetProps<CriteriaForSearch>({
                ...newCriteria,
                attendees: { ...newCriteria?.attendees, kids: newKids },
              }),
            );
          },
          dateFormat,
          dayPlaceholder,
          kids: newCriteria?.attendees.kids || [],
          kidsAgeLabel: t('faceting.who.ageSectionSubtitle'),
          kidsAgeLimitLabel: t('faceting.who.kidsAgeLimit'),
          kidsLabel: t('faceting.who.kids'),
          kidsValidationState: newCriteria?.attendees.kids.map(({ status }) => status),
          label: t('faceting.who.subTitle'),
          minAdultsNumber: ADULTS_NUMBER_MIN,
          monthPlaceholder,
          setAdultsNumber: (newAdultNumber) => {
            setNewCriteria(
              makeWidgetProps<CriteriaForSearch>({
                ...newCriteria,
                attendees: { ...newCriteria?.attendees, adults: newAdultNumber },
              }),
            );
          },
          updateOnInvalidBirthDate: true,
          validateKidsBirthdate: (kidIdx) => {
            newCriteria.attendees.kids.map((kid, index) =>
              index === kidIdx ? { ...kid, status: IS_INVALID } : kid,
            );
          },
          yearPlaceholder,
        })}
      />
    </div>
  );
};
